<template>
  <div class="articles" ref='vantaRef'>
   <div class="content">
      <div class="left">
         <el-input
            placeholder="请输入内容"
            prefix-icon="el-icon-search"
            style="margin: 30px 0;"
            @change="getArticles()"
            v-model="keywords">
          </el-input>
         <Categories @getList="getArticleList" title="分类" :list="titList"/>
         <SideContent style="margin: 30px 0; " title="站长推荐" :list="classifyList"/>
         <SideContent title="点击排行" :list="rankList"/>
      </div>
      <div class="right">
        <div v-for="item in articles" style="margin-bottom: 30px;border-radius: 24px;overflow: hidden;cursor: pointer;" @click="enterInfo(item.id)">
          <ArticleList :article="item"/>
        </div>
        <el-pagination
         background
         class="pagination"
         style="margin: 20px 0;"
         @size-change="handleSizeChange"
         @current-change="handleCurrentChange"
         :current-page="currentPage"
         :page-sizes="[10, 20, 50, 100]"
         :page-size="limit"
         layout="total, sizes, prev, pager, next, jumper"
         :total="total">
        </el-pagination>
      </div>
   </div>
  </div>
</template>

<script>
  import ArticleList from '../../components/ArticleList.vue'
  import Myself from '../../components/Myself.vue'
  import SideContent from '../../components/SideContent.vue'
  import Categories from './components/Categories.vue'
  import {animateBg} from '../../utils/mixins.js'
  export default{
    components:{
      ArticleList,
      Myself,
      SideContent,
      Categories
    },
    data(){
      return {
        keywords:'',
        classifyList:[],
        rankList:[],
        currentPage:1,
        articles:[],
        total:0,
        page:1,
        limit:10,
        titList:[],
        classify_id:0
      }
    },
    created() {
      this.getCategory()
      this.getRanking()
      this.getClickRank()
      this.getArticles()
    },
    mixins:[animateBg],
    methods:{
      getArticleList(id){
        this.classify_id = id
        this.getArticles()
      },
      // 进入文章详情页
      enterInfo(id){
        this.$router.push({
          path:'/articleInfo/'+id,
        })
      },
      handleSizeChange(val) {
              this.limit = val
              this.getArticles()

            },
      handleCurrentChange(val) {
              this.page = val
              this.getArticles()
            },
    // 获取分类列表
      getCategory(){
        const timestamp = Date.now().toString().substring(0,10)
        this.$api.getCategoryList({t:'json',timestamp})
        .then(res=>{
          if(res.code == 200){
            this.titList = [{id:0,name:'全部'},...res.data]
          }else{
            console.log(res.msg)
          }
        })
        .catch(err=>{
          console.log(err)
        })
      },
      // 站长推荐
      getRanking(){
        const timestamp = Date.now()
        this.$api.getRecList({t:'json',timestamp})
        .then(res=>{
          if(res.code == 0){
            this.classifyList = res.data
          }else{
            console.log(res.msg)
          }
        })
        .catch(err=>{
          console.log(err)
        })
      },
      // 点击排行
      getClickRank(){
        const timestamp = Date.now()
        this.$api.getClickRank({t:'json',timestamp})
        .then(res=>{
          if(res.code == 0){
            this.rankList = res.data
          }else{
            console.log(res.msg)
          }
        })
        .catch(err=>{
          console.log(err)
        })
      },
      // 文章列表
      getArticles(){
        const  timestamp = Date.now()
        this.$api.getArticles({t:'json',timestamp,keywords:this.keywords,page:this.page,limit:this.limit,classify_id:this.classify_id})
          .then(res=>{
            if(res.code == 0){
                this.total = res.count
                this.articles = res.data
            }else{
              console.log(res.msg)
            }
          })
          .catch(err=>{
            console.log(err)
          })
      }
    },
  }
</script>

<style lang="scss">
  .articles{
    background-color: transparent;
    margin-top: 20px;
    height: calc(100vh - 120px);
    .content{
     display: flex;
     justify-content: space-between;
     background-color: rgba(999, 999, 999, .6);
     // min-height: calc(100vh - 129px - 20px);
     width: 60%;
     margin: 0 auto;
     .left{
        width: 28%;
        margin-left: 20px;
     }
     .right{
       position: relative;
       height:calc(100vh - 122px);
       overflow-y: scroll;
       overflow-x: hidden;
       width: 68%;
       margin-right: 20px;
       .pagination{
         position: relative;
         bottom: 10px;
         left: 0;
       }
     }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/articles/articles.vue